import * as actionTypes from "../actionTypes";

const initialState = {};

// object to array
function objToArr(obj) {
  const arr = [];
  for (const key in obj) {
    arr.push({
      value: key,
      label: obj[key],
    });
  }
  return arr;
}

const orderSettingReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SAVE_ORDER_SETTINGS:
      const accounts = objToArr(payload.accounts);
      const recipients = objToArr(payload.recipients);
      return {
        ...state,
        ...payload,
        accounts,
        recipients: [{ value: 0, label: "Select All" }, ...recipients],
      };

    case actionTypes.SAVE_ORDER_TRANSFER_DATA: {
      console.log(payload);
      const accounts = objToArr(payload.accounts);
      const eligible_transfer_arr = objToArr(payload.eligible_transfer_arr);
      const userId = payload.data.id;

      return {
        ...state,
        order_transfer_data: {
          ...payload,
          userId,
          eligible_transfer_arr,
          accounts,
        },
      };
    }
    case actionTypes.SAVE_ORDER_TRANSFER_SECONDARY_ACCOUNT: {
      const accounts = objToArr(payload.accounts);
      return {
        ...state,
        order_transfer_data: {
          ...state.order_transfer_data,
          secondaryAccounts: [
            { value: "", label: "Select All" },
            ...accounts,
            // { value: "4", label: "four" },
            // { value: "5", label: "five" },
          ],
        },
      };
    }
    case actionTypes.SAVE_TRANSFER_ACCOUNT_EDIT_DETAILS: {
      const accounts = objToArr(payload.accounts);
      const second_account = objToArr(payload.second_accound);
      return {
        ...state,
        editAccountDetails: { ...payload, accounts, second_account },
      };
    }
    default:
      return state;
  }
};

export default orderSettingReducer;
